import { Button } from '@/components/ui-kit/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui-kit/card';
import { useCopyToClipboard } from '@/hooks/use-copy-to-clipboard';
import { showSuccessToast } from '@/hooks/use-toast';
import { Check, Copy } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type PlatformIntegrationCardProps = {
  name: string;
  imageUrl: string;
  description: string;
  script: string;
};

export const PlatformIntegrationCard = ({
  name,
  imageUrl,
  description,
  script,
}: PlatformIntegrationCardProps) => {
  const { t } = useTranslation();
  const { isCopying, copy } = useCopyToClipboard();
  return (
    <Card>
      <CardHeader className="mb-2 flex flex-row items-center justify-between">
        <CardTitle className="flex flex-row items-center gap-2 text-sm">
          <img alt={name} src={imageUrl} width="16" height="16" />

          <span>{name}</span>
        </CardTitle>
        <Button
          variant="ghost"
          size="sm"
          disabled={isCopying}
          className="h-fit w-fit p-0"
          type="button"
          onClick={() =>
            copy(script, () => showSuccessToast({ description: t('SCRIPT_COPIED', { name }) }))
          }
        >
          {isCopying ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
        </Button>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">{description}</p>
      </CardContent>
    </Card>
  );
};
